'use client'

import { AuthPageHeading } from '@/shared/ui/headings'
import { CountdownButton, useCountdownStore } from '@/entities/countdown-button'
import { NavigateBackIcon } from '@/shared/ui/navigation-back'
import { Card, CardContent, CardFooter } from '@/shared/ui/card'
import { Mail } from 'lucide-react'
import Link from 'next/link'
import { useConfirmEmailStore } from '../model'

export interface ConfirmEmailCardProps {
  onBack?: () => void
  onSubmit?: () => void
}

export default function ConfirmEmailCard({ onBack, onSubmit }: ConfirmEmailCardProps) {
  const email = useConfirmEmailStore().email || ''
  if (!email) return null

  return (
    <Card className="relative px-[20px] max-w-[400px] sm:px-[40px] py-[40px] min-h-[480px] max-h-9dvh shadow-none border-none overflow-y-auto flex flex-col justify-between">
      <AuthPageHeading
        title={<>Подтвердите почту</>}
        description={
          <>
            Ссылка для подтверждения почты отправлена на 
            <Link className="text-primary underline" href={`mailto:${email}`}>
              {email}
            </Link>
          </>
        }
      />
      <CardContent className="p-0">
        <Mail size="100" className="m-auto" />
      </CardContent>
      <CardFooter className="p-0 flex flex-col gap-2">
        <CountdownButton onClick={onSubmit} className="w-full">
          Отправить повторно
        </CountdownButton>

        <NavigateBackIcon className="w-full" size="lg" variant="ghost" onClick={onBack}>
          Вернуться назад
        </NavigateBackIcon>
      </CardFooter>
    </Card>
  )
}
